module.exports = __webpack_public_path__ + "img/mascot-1.f624c5ab.png";